<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 158.891 249"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title
      v-if="iconName !== ''"
      :id="iconName"
      lang="en"
    >{{ iconName }} icon</title>
    <g id="Group_3350" data-name="Group 3350" transform="translate(0 0)">
      <g id="Group_3349" data-name="Group 3349">
        <g id="Group_3348" data-name="Group 3348">
          <path :fill="iconColor" id="Path_4276" data-name="Path 4276" d="M849.049,1677.908h.54a12.994,12.994,0,0,0,12.979-12.98v-10.435a55.719,55.719,0,0,0,35.85-51.99V1573.24a23.483,23.483,0,0,0-3.091-45.934v-38.531a18.542,18.542,0,0,0-37.085,0V1527.1h-30.9v-38.321a18.542,18.542,0,0,0-37.085,0v38.531a23.482,23.482,0,0,0-3.091,45.934V1602.5a55.718,55.718,0,0,0,35.849,51.99v10.436a12.993,12.993,0,0,0,12.979,12.979h13.059ZM870.6,1488.775a6.181,6.181,0,1,1,12.361,0V1527.1H870.6Zm-67.989,0a6.181,6.181,0,1,1,12.362,0V1527.1H802.615Zm-20.4,61.808a11.14,11.14,0,0,1,11.126-11.126h98.893a11.126,11.126,0,0,1,0,22.253H793.345A11.139,11.139,0,0,1,782.218,1550.583Zm17.307,51.92v-28.432h86.531V1602.5a43.266,43.266,0,0,1-86.531,0Zm43.5,63.043c-.051,0-.1-.006-.155-.006s-.1.006-.155.006h-6.722a.618.618,0,0,1-.619-.617v-7.295a55.659,55.659,0,0,0,14.833,0v7.295a.617.617,0,0,1-.618.617Z" transform="translate(-769.857 -1470.233)" />
        </g>
      </g>
    </g>
    <g v-if="type === 'A'" id="Group_3351" data-name="Group 3351" transform="translate(54.182 114.129)">
      <path :fill="iconColor" id="Path_4277" data-name="Path 4277" d="M857.893,1631.147l-1.969-5.174H839.162l-1.969,5.288a18.525,18.525,0,0,1-1.969,4.176,3.13,3.13,0,0,1-2.672,1.083,3.919,3.919,0,0,1-2.785-1.153,3.532,3.532,0,0,1-1.209-2.616,5.836,5.836,0,0,1,.281-1.743q.281-.9.928-2.5l10.547-26.777,1.083-2.769a14.006,14.006,0,0,1,1.351-2.687,5.49,5.49,0,0,1,1.885-1.73,5.779,5.779,0,0,1,2.883-.661,5.846,5.846,0,0,1,2.911.661,5.608,5.608,0,0,1,1.884,1.7,11.965,11.965,0,0,1,1.209,2.236q.493,1.2,1.253,3.193l10.772,26.608a13.338,13.338,0,0,1,1.266,4.416,3.652,3.652,0,0,1-1.2,2.629,3.934,3.934,0,0,1-2.883,1.2,3.7,3.7,0,0,1-1.687-.353,3.431,3.431,0,0,1-1.182-.955,8.8,8.8,0,0,1-1.027-1.856Q858.288,1632.1,857.893,1631.147ZM841.356,1619.7h12.318l-6.215-17.016Z" transform="translate(-828.558 -1593.88)" />
    </g>
    <g v-else-if="type === 'B'">
      <path :fill="iconColor" d="M74.7,157.62H61.41c-1.92,0-3.29-0.43-4.11-1.29c-0.82-0.86-1.23-2.23-1.23-4.11v-32.69
        c0-1.92,0.42-3.3,1.26-4.14c0.84-0.84,2.2-1.26,4.08-1.26H75.5c2.08,0,3.88,0.13,5.4,0.39c1.52,0.26,2.89,0.75,4.09,1.48
        c1.03,0.61,1.94,1.39,2.73,2.33s1.39,1.98,1.81,3.12c0.42,1.14,0.62,2.34,0.62,3.6c0,4.35-2.18,7.54-6.53,9.55
        c5.72,1.82,8.57,5.36,8.57,10.62c0,2.43-0.62,4.62-1.87,6.57c-1.25,1.95-2.93,3.39-5.04,4.32c-1.32,0.55-2.85,0.94-4.57,1.17
        S77,157.62,74.7,157.62z M64.88,120.75v11.24h8.07c2.2,0,3.89-0.21,5.09-0.62s2.11-1.21,2.74-2.37c0.49-0.83,0.74-1.76,0.74-2.79
        c0-2.2-0.78-3.65-2.34-4.38c-1.56-0.72-3.95-1.08-7.15-1.08H64.88z M74.05,138.31h-9.17v12.7h9.46c5.95,0,8.93-2.15,8.93-6.44
        c0-2.2-0.77-3.79-2.31-4.78C79.42,138.8,77.11,138.31,74.05,138.31z"/>
    </g>
    <g v-else-if="type === 'C'" id="Group_3358" data-name="Group 3358" transform="translate(55.499 115.353)">
      <path :fill="iconColor" id="Path_4281" data-name="Path 4281" d="M1211.63,1623.244a10.654,10.654,0,0,1-.941,4.131,14.871,14.871,0,0,1-2.959,4.364,15.08,15.08,0,0,1-5.154,3.477,18.522,18.522,0,0,1-7.309,1.337,25.5,25.5,0,0,1-5.754-.6,16.137,16.137,0,0,1-4.705-1.869,15.825,15.825,0,0,1-3.885-3.34,19.835,19.835,0,0,1-2.7-4.212,22.02,22.02,0,0,1-1.678-4.979,27.119,27.119,0,0,1-.56-5.616,24.891,24.891,0,0,1,1.4-8.646,18.443,18.443,0,0,1,4.023-6.531,17.593,17.593,0,0,1,6.137-4.134,19.9,19.9,0,0,1,7.5-1.417,18.743,18.743,0,0,1,8.644,1.936,15.659,15.659,0,0,1,5.81,4.786,9.46,9.46,0,0,1,2.018,5.385,3.507,3.507,0,0,1-.983,2.455,3.112,3.112,0,0,1-2.372,1.064,3.275,3.275,0,0,1-2.332-.737,10.172,10.172,0,0,1-1.732-2.537,12.218,12.218,0,0,0-3.724-4.445,9.1,9.1,0,0,0-5.276-1.471,9.562,9.562,0,0,0-7.95,3.791q-2.96,3.79-2.959,10.774a19.974,19.974,0,0,0,1.311,7.757,9.78,9.78,0,0,0,3.708,4.623,10.232,10.232,0,0,0,5.618,1.527,9.856,9.856,0,0,0,5.9-1.731,10.462,10.462,0,0,0,3.641-5.087,8.652,8.652,0,0,1,1.284-2.579,2.9,2.9,0,0,1,2.454-.994,3.43,3.43,0,0,1,2.481,1.009A3.367,3.367,0,0,1,1211.63,1623.244Z" transform="translate(-1175.985 -1595.207)"/>
    </g>
    <g id="Group_3352" data-name="Group 3352" transform="translate(67.512 129.931)">
      <path :fill="iconColor" id="Path_4278" data-name="Path 4278" d="M888.689,1730.07c-25.193,0-45.689-19.253-45.689-42.92v-3.231a5.538,5.538,0,1,1,11.076,0v3.231c0,17.558,15.527,31.844,34.613,31.844s34.614-14.286,34.614-31.844v-70.611a5.538,5.538,0,1,1,11.076,0v70.611C934.378,1710.816,913.882,1730.07,888.689,1730.07Z" transform="translate(-843 -1611)"/>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
